export function jobStatus(jobExt) {
    const { progress, classify_result, classify_worker_pref, status } = jobExt;
    const { branch } = progress || {};

    if (status === 'pending' && branch === 'dont-qualify-ic') return branch;
    if (status === 'pending' && classify_worker_pref === 'ic' && branch === 'ic-continue-request') return branch;
    if (status === 'active') return classify_result;
    return classify_worker_pref;
}

export function isW2(job) {
    const { classify_result, progress } = job;
    return job && (classify_result === 'w2' || (classify_result === 'tbd' && (progress || {}).branch === 'w2'));
}



// WEBPACK FOOTER //
// ./src/utilities/jobStatus.jsx